import MenuItemGridView from "./MenuItemGridView";
import MenuItemListView from "./MenuItemListView";
import { useSettings } from "../context/SettingsContext";

const MenuItemList = ({ items, onView, selectedCatId, onRefreshCategories, firstItemRef }) => {
  const { settings } = useSettings();

  if (!items || items.length === 0) return null;

  // ✅ Switch View
  if (settings?.menu_view == 0) {
    return (
      <MenuItemListView
        items={items}
        onView={onView}
        selectedCatId={selectedCatId}
        onRefreshCategories={onRefreshCategories}
        firstItemRef={firstItemRef}
      />
    );
  }

  // ✅ Default Grid View (existing)
  return (
    <MenuItemGridView
      items={items}
      onView={onView}
      selectedCatId={selectedCatId}
      onRefreshCategories={onRefreshCategories}
      firstItemRef={firstItemRef}
    />
  );
};

export default MenuItemList;
